// Reusable form data mapping utility to reduce code duplication

export const createBaseRequestData = (formData) => ({
  sender_first_name: formData.senderFirstName,
  sender_last_name: formData.senderLastName,
  sender_phone: formData.senderPhoneNumber,
  sender_email: formData.senderEmail,
  sender_country: formData.senderCountry,
  sender_city: formData.senderCity,
  sender_postal_code: formData.senderPostalCode,
  sender_street_address: formData.senderStreet,
  receiver_first_name: formData.receiverFirstName,
  receiver_last_name: formData.receiverLastName,
  receiver_phone: formData.receiverPhoneNumber,
  receiver_email: formData.receiverEmail,
  receiver_country: formData.receiverCountry,
  receiver_city: formData.receiverCity,
  receiver_postal_code: formData.receiverPostalCode,
  receiver_street_address: formData.receiverStreet,
  preferred_currency: formData.preferredCurrency,
  payment_method: formData.paymentMethod,
  additional_info: formData?.additionalInfo || "",
});

export const createPackageData = (formData) => ({
  weight: formData.weight,
  length: formData.length,
  width: formData.width,
  height: formData.height,
});

export const createCourierRequestData = (formData) => ({
  ...createBaseRequestData(formData),
  ...createPackageData(formData),
  number_of_packages: 1,
  package_description: formData.packageDescription,
  service_type: formData.serviceType,
  pick_up_date: formData.pickupDateTime,
});

export const createAirFreightRequestData = (formData) => ({
  ...createBaseRequestData(formData),
  ...createPackageData(formData),
  number_of_packages: formData.packageCount,
  type_of_goods: formData.typeOfGoods,
  value_of_goods: formData.valueOfGoods,
  preferred_shipping_date: formData.shippingDate,
  destination: formData.destinationAirport,
  additional_info: formData?.additionalInfo || "Nothing",
});

export const createSeaFreightRequestData = (formData) => ({
  ...createBaseRequestData(formData),
  container_type: formData.containerType,
  type_of_goods: formData.typeOfGoods,
  number_of_containers: formData.numberOfContainer,
  weight: formData.weight,
  value_of_goods: formData.valueOfGoods,
  preferred_shipping_date: formData.shippingDate,
  destination_port: formData.destinationPort,
  shipping_mode: formData.shippingMode,
});

export const createRailFreightRequestData = (formData) => ({
  ...createBaseRequestData(formData),
  ...createPackageData(formData),
  type_of_goods: formData.typeOfGoods,
  number_of_palettes: formData.numberOfContainer,
  preferred_shipping_date: formData.prefferredShippingDate,
  destination_station: formData.destinationStation,
});

export const createRoadTransportRequestData = (formData) => ({
  ...createBaseRequestData(formData),
  ...createPackageData(formData),
  type_of_goods: formData.typeOfGoods,
  number_of_packages: formData.packageCount,
  value_of_goods: formData.valueOfGoods,
  preferred_pickup_date: formData.preferredPickUpDate,
  preferred_shipping_date: formData.shippingDate,
  destination_port: formData.deliveryStation,
  vehicle_type: formData.vehicleType,
});

export const createRelocationRequestData = (formData) => ({
  from_country: formData.countryFrom,
  from_city: formData.cityFrom,
  from_postal_code: formData.postalCodeFrom,
  from_address: formData.addressFrom,
  to_country: formData.countryTo,
  to_city: formData.cityTo,
  to_postal_code: formData.postalCodeTo,
  to_address: formData.addressTo,
  type_of_relocation: formData.typeOfRelocation,
  list_of_items: formData.listOfItems,
  preferred_moving_date: formData.preferredMovingDate,
  preferred_currency: formData.preferredCurrency,
  payment_method: formData.paymentMethod,
  additional_info: formData.additionalInfo,
});